import { Injectable } from '@angular/core';
import { User, UsersService } from '@era/security-sdk';
import { UserResolverActions, SuggestedUserApiActions } from './suggested-user.actions';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { mergeMap } from 'rxjs/operators';
import { safeMap } from '../effects.helpers';

@Injectable()
export class SuggestedUserEffects {
  constructor(
    private readonly userService: UsersService,
    private readonly actions$: Actions
  ) {}

  suggestedUserLoadedEffect$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(UserResolverActions.suggestedUsersRequested),
      mergeMap(() =>
        safeMap(
          this.userService.searchForNewUsers(),
          (suggestedUsers: User[]) => SuggestedUserApiActions.suggestedUsersLoaded({ suggestedUsers }),
          (error) => SuggestedUserApiActions.errorLoadingSuggestedUsers({ error })
        )
      )
    );
  });
}
